import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import * as actions from './actions'

function* loadRentalPrice(action) {
    const {
        data: {
            page,
            pageSize,
            orderBy,
            orderType,
            company_id,
            filterObj,
            type,
            limit_export,
            file_value_pdf,
            accessToken,
        },
    }= action.payload

    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-rental-price-lists`,
            {
                page,
                pageSize,
                orderBy,
                orderType,
                company_id,
                filterObj,
                type,
                limit_export,
                file_value_pdf,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
        yield put(actions.loadRentalPrice.success(res.data, page, pageSize))
    } catch (err) {
        console.log(err.message)
        yield put(actions.loadRentalPrice.failure())
    }
}

function* exportRentalPrice(action) {
    const {
        data: {
            page,
            pageSize,
            orderBy,
            orderType,
            company_id,
            filterObj,
            type,
            limit_export,
            file_value_pdf,
            accessToken,
        },
    }= action.payload

    try {
        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-rental-price-lists`,
            {
                page,
                pageSize,
                orderBy,
                orderType,
                company_id,
                filterObj,
                type,
                limit_export,
                file_value_pdf,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )
        yield put(actions.exportRentalPrice.success(res.data, page, pageSize))
        const sftpPath = res.data.data
        const downloadRes = yield call(
          axios.post,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/download-report`,
          { sftp_path: sftpPath },
          { headers: { Authorization: `Bearer ${accessToken}` }, responseType: 'blob' },
        )
        const ext = sftpPath.split('.').pop().toLowerCase()
        const mimeType = ext === 'csv' ? 'text/csv' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const blob = new Blob([downloadRes.data], { type: mimeType })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = sftpPath.split('/').pop()
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
    } catch (err) {
        console.log(err.message)
        yield put(actions.exportRentalPrice.failure())
    }
}

function* createRentalPrice(action) {
    const {
        data: {
            vehicle_type_id,
            companies_id,
            start_date,
            expired_date,
            min_quantity,
            quantity_unit,
            service_charge,
            excess_service_charge,
            accessToken
        },
        loading,
    } = action.payload

    try {

        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/create-rental-price`,
            {
                vehicle_type_id,
                companies_id,
                start_date,
                expired_date,
                min_quantity,
                quantity_unit,
                service_charge,
                excess_service_charge,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )

        loading(res.data)
        yield put(actions.createRentalPrice.success(res.data))
    } catch (err) {
        yield put(actions.createRentalPrice.failure())
    }
}

function* updateRentalPrice(action) {
    const {
        data: {
            id,
            vehicle_type_id,
            companies_id,
            start_date,
            expired_date,
            min_quantity,
            quantity_unit,
            service_charge,
            excess_service_charge,
            accessToken,
        },
        loading,
    } = action.payload

    try {

        const res = yield call(
            axios.post,
            `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/update-rental-price`,
            {
                id,
                vehicle_type_id,
                companies_id,
                start_date,
                expired_date,
                min_quantity,
                quantity_unit,
                service_charge,
                excess_service_charge,
            },
            { headers: { Authorization: `Bearer ${accessToken}` } },
          )

        loading(res.data)
        yield put(actions.updateRentalPrice.success(res.data))
    } catch (err) {
        yield put(actions.updateRentalPrice.failure())
    }
}

function* loadRentalPriceDetail(action) {
    const {
        data: { id, accessToken },
    } = action.payload
    try {
        const res = yield call(
          axios.get,
          `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/get-rental-price-detail/${id}`,
          { headers: { Authorization: `Bearer ${accessToken}` } },
        )
        yield put(actions.loadRentalPriceDetail.success(res.data))
      } catch (err) {
        console.log(err.message)
        yield put(actions.loadRentalPriceDetail.failure())
      }
}

export default function* watchRentalPrice() {
    yield all([
        takeEvery(actions.LOAD_RENTAL_PRICE.REQUEST, loadRentalPrice),
        takeEvery(actions.CREATE_RENTAL_PRICE.REQUEST, createRentalPrice),
        takeEvery(actions.UPDATE_RENTAL_PRICE.REQUEST, updateRentalPrice),
        takeEvery(actions.LOAD_RENTAL_PRICE_DETAIL.REQUEST, loadRentalPriceDetail),
        takeEvery(actions.EXPORT_RENTAL_PRICE.REQUEST, exportRentalPrice),
    ])
}

export {
    loadRentalPrice, 
    createRentalPrice, 
    updateRentalPrice, 
    loadRentalPriceDetail,
    exportRentalPrice
}